import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import {
	Button,
	Chip,
	Collapse,
	Divider,
	Drawer,
	FormControlLabel,
	Radio,
	RadioGroup,
	Slider,
	TextField,
	Typography,
	ToggleButton, ToggleButtonGroup } from '@mui/material';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import AddIcon from '@mui/icons-material/Add';

const useStyles = makeStyles((theme) => ({
	root: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
	},
	drawer: {
		width: 420,
		maxWidth: '100%',
	},
	header: {
		padding: theme.spacing(2, 1),
		display: 'flex',
		justifyContent: 'space-between',
	},
	buttonIcon: {
		marginRight: theme.spacing(1),
	},
	content: {
		padding: theme.spacing(0, 3),
		flexGrow: 1,
	},
	contentSection: {
		padding: theme.spacing(2, 0),
	},
	contentSectionHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		cursor: 'pointer',
	},
	contentSectionContent: {},
	formGroup: {
		padding: theme.spacing(2, 0),
	},
	fieldGroup: {
		display: 'flex',
		alignItems: 'center',
	},
	field: {
		marginTop: 0,
		marginBottom: 0,
	},
	flexGrow: {
		flexGrow: 1,
	},
	addButton: {
		marginLeft: theme.spacing(1),
	},
	tags: {
		marginTop: theme.spacing(1),
	},
	minAmount: {
		marginRight: theme.spacing(3),
	},
	maxAmount: {
		marginLeft: theme.spacing(3),
	},
	radioGroup: {},
	actions: {
		padding: theme.spacing(3),
		'& > * + *': {
			marginTop: theme.spacing(2),
		},
	},
}));

const FiltersDrawer = (props) => {
	const { open, onClose, onFilter, className, children, filterDisabled, onClear, ...rest } = props;
	const classes = useStyles();

	return (
		<Drawer
			anchor="right"
			classes={{ paper: classes.drawer }}
			onClose={onClose}
			open={open}
			variant="temporary"
		>
			<div
				{...rest}
				className={clsx(classes.root, className)}
			>
				<div className={classes.header}>
					<Button onClick={onClose} size="small">
						<CloseIcon className={classes.buttonIcon} />
						Close
					</Button>
				</div>
				<div className={classes.content}>
					{children}
				</div>
				<div className={classes.actions}>
					{onClear && (
						<Button fullWidth onClick={onClear} variant="contained">
							<DeleteIcon className={classes.buttonIcon} />
							Clear
						</Button>
					)}
					<Button
						color="primary"
						fullWidth
						variant="contained"
						onClick={onFilter}
						disabled={filterDisabled}
					>
						Apply filters
					</Button>
				</div>
			</div>
		</Drawer>
	);
};

FiltersDrawer.propTypes = {
	className: PropTypes.string,
	onClose: PropTypes.func,
	onFilter: PropTypes.func,
	open: PropTypes.bool.isRequired,
	children: PropTypes.object,
	filterDisabled: PropTypes.bool,
	onClear: PropTypes.func
};

export default FiltersDrawer;
